// extracted by mini-css-extract-plugin
export default {"loader":"RankingTraitsList_loader__UToZK","fullRow":"RankingTraitsList_fullRow__B3mZu","notFound":"RankingTraitsList_notFound__whjo-"};